




























































import {
  OpportunityIcon,
  OpportunityStatus,
} from '@/components/opportunities';
import { OpportunityNewsItem } from '@/models/dashboard';
import { OpportunityListItem, OpportunityItemStatus } from '@/models/opportunities';
import { isOpportunityInactive } from '@/shared';
import { Actions, typedStore } from '@/store';
import Vue from 'vue';

export default Vue.extend({
  name: 'OpportunitiesNews',
  components: {
    OpportunityIcon,
    OpportunityStatus,
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      loader: {
        isOpportunitiesNewsListPending: false,
      },
    };
  },
  created() {
    this.fetchOpportunitiesNews();
  },
  computed: {
    opportunitiesNews(): OpportunityNewsItem[] {
      return typedStore(this).state.opportunities.news;
    },
    areMoreItemsAvailable(): boolean {
      return this.opportunitiesNews.length < typedStore(this).state.opportunities.pagination.totalCount;
    },
  },
  methods: {
    goToOpportunityDetails(id: string) {
      this.$router.push({ name: 'opportunity-details', params: { id } });
    },

    async fetchOpportunitiesNews() {
      this.loader.isOpportunitiesNewsListPending = true;
      try {
        await this.$store.dispatch(Actions.opportunities.fetchNews);
      } finally {
        this.loader.isOpportunitiesNewsListPending = false;
      }
    },
    isOpportunityInactive,
  },
});
